module.exports = __webpack_public_path__ + "img/CFJJ_Logo.cd960d95.jpg";